import { ClientDataEntryView, ClientView, ClientViewOptions } from '../../../clients/views/client-view';
import { customElement } from 'lit/decorators.js';
import { DataEntryOwner } from '../../../../webmodule-common/other/ui/DataEntryOwner';
import { FranchiseeClientDetailView } from './franchisee-client-detail-view';
import { showValidations } from '../../../../webmodule-common/other/ui/modal-validationhandler';
import { Snippet } from '../../../../webmodule-common/interop/webmodule-interop';

@customElement('wm-franchiseeclientdataentryview')
export class FranchiseeClientDataEntryView extends ClientDataEntryView {
  constructor(options: ClientViewOptions, owner: DataEntryOwner) {
    super(options, owner);
  }

  protected clientDetailViewFactory(): FranchiseeClientDetailView {
    return new FranchiseeClientDetailView(this, {
      clientContainerManager: this.clientContainerManager
    });
  }
  protected async checkValidations(): Promise<boolean> {
    const errors = this.getValidationErrors();
    if (errors.length != 0) {
      await showValidations(errors);
      return false;
    }
    return true;
  }
}
@customElement('wm-franchiseeclientview')
export class FranchiseeClientView extends ClientView {
  options: ClientViewOptions;

  constructor(options: ClientViewOptions) {
    super(options);
    this.options = options;
  }
  protected getTitle(): Snippet {
    return this.view?.getTitle() ?? '';
  }

  protected createView(): ClientDataEntryView {
    return new FranchiseeClientDataEntryView(this.options, this);
  }
}
